import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CloudinaryImageUpdateRequest } from '@core/data/api/cloudinary/cloudinary-image-update-request';
import { IAppState } from '@core/state/app/app-state';
import { UpdateCloudinaryAvatarAction } from '@core/state/shared/actions/cloudinary-actions';
import { IObservableAction } from '@core/state/shared/actions/observable-action';
import { isUndefined } from '@core/utils/object';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { Observable, Observer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImageService {

    private urls: any = {
        getSignature: environment.api.util + '/s/cl',
    };
    
    constructor(private store$: Store<IAppState>,
                private http: HttpClient,
                @Inject(DOCUMENT) private document) {}

    updateAvatarInCloudinary(targetId: string, request: CloudinaryImageUpdateRequest): IObservableAction {
        const action: any = new UpdateCloudinaryAvatarAction({
            targetId,
            request
        });
        this.store$.dispatch(action);

        return action;
    }

    getSignature(target, type, tags) {
        return this.http.post(this.urls.getSignature, { target, type, tags });
    }

    uploadFileToCloudinary(
        url,
        apiKey,
        timestamp,
        signature,
        publicId,
        tags,
        fileStream
    ) {
        return this.http.post(url, {
            file: fileStream,
            api_key: apiKey,
            timestamp,
            signature,
            public_id: publicId,
            base_api_url: url,
            tags,
        });
    }
    
    base64ToImageFile(base64: string, filename: string, mimeType: string):Promise<File> {

        mimeType = mimeType || (base64.match(/^data:([^;]+);/)||'')[1];

        return (fetch(base64)
            .then((res) => res.arrayBuffer())
            .then((buf) => new File([buf], filename, {type:mimeType}))
        );
    }

    dataURLtoBase64(latestImage: any, mimeType: string): Observable<string> {
        return new Observable((observer: Observer<string>) => {
            const img: HTMLImageElement = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = isUndefined(latestImage.large_url)? latestImage: latestImage.large_url;

            if(!img.complete) {
                img.onload = () => {
                    observer.next(this.getBase64Image(img, mimeType));
                    observer.complete();
                }
            } else {
                observer.next(this.getBase64Image(img, mimeType));
                observer.complete();
            }
        });
    }

    getBase64Image(img: HTMLImageElement, mimeType: string): string {
        const canvas: HTMLCanvasElement = this.document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL: string = canvas.toDataURL(mimeType);
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
    }
}
